import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {SettingsMobileDropdown} from '@mintdata-wsp/wsp/ui/views/workspace/settings/SettingsMobileDropdown';
import {SettingsRoutes} from '@mintdata-wsp/wsp/ui/views/workspace/settings/SettingsPanel';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SettingsHeader.less');
const cx = classnames.bind(styles);

export interface SettingsHeaderProps
{
    text?:string;
    className?:string;
    selectedRoute?:SettingsRoutes;
}

@observer
export class SettingsHeader extends React.Component<SettingsHeaderProps, any>
{
    private _onSelectMenuItem = (subUrl:SettingsRoutes) =>
    {
        controllers.navigation.navigateTo(`${paths.settings()}/${subUrl}`);
    };

    render()
    {
        let {className, text, selectedRoute} = this.props;

        return (
            <Row className={cx('settingsHeader', className)}>

                {
                    text &&
                    <Column className={cx('settingsTitle')}>
                        {this.props.text}
                    </Column>
                }

                {
                    selectedRoute &&
                    <SettingsMobileDropdown
                        selectedRoute={selectedRoute}
                        onSelect={this._onSelectMenuItem}
                    />
                }

                {this.props.children}

            </Row>
        );
    }
}





